import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import InvalidUserAlert from 'modules/blocks/InvalidUserAlert';
import {containers as BaseContainers} from '../modules/core';
import {containers as ProfileContainer} from '../modules/profile';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import customBaseTheme from 'modules/theme/customBaseTheme';
const {
  Header,
  Sidebar,
  Footer
} = BaseContainers;

const {
  Profile,
  Logout
} = ProfileContainer;

export default class extends Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(customBaseTheme)} key={3}>
        <div className="public-wrap">
          <Header/>
          <InvalidUserAlert/>
          <Switch>
            <Route path="/settings" component={Profile}/>
            <Route path="/logout" component={Logout}/>
            <Redirect to="/settings"/>
          </Switch>
          <Sidebar/>
          <Footer/>
        </div>
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/invalid_user.js